/* Play and earn (CLAUDE.md §4, docs/23 §3.4): the game opens with a token tying its plays to this account. Points for playing, never for downloading. */
import { api, ApiError } from './api.js';
import { openExternal } from './open.js';

/** Open a game linked to this account. Returns an error to show, or null. */
export async function playGame(gameId: string): Promise<string | null> {
  try {
    const r = await api<{ url: string }>(`/api/me/games/${encodeURIComponent(gameId)}/play`, { body: {} });
    if (!r.url) return 'Could not open the game. Try again.';
    await openExternal(r.url);
    return null;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return 'Games open soon.';
    return e instanceof Error ? e.message : 'Could not open the game';
  }
}
